import { Reveal, Eyebrow } from "./Reveal";

const EDUCATION = [
  {
    id: "education-timeline-dnb",
    degree: "DNB Pediatrics",
    period: "2022 – 2024",
    institution: "Nirmal Hospital Pvt Ltd, Surat",
    body: "National Board of Examinations, New Delhi",
  },
  {
    id: "education-timeline-dch",
    degree: "Diploma in Child Health (DCH)",
    period: "2018 – 2020",
    institution: "Grant Government Medical College & Sir JJ Group of Hospitals, Mumbai",
    body: "MUHS, Nashik",
  },
  {
    id: "education-timeline-mbbs",
    degree: "MBBS",
    period: "2010 – 2015",
    institution: "NKP Salve Institute of Medical Sciences & Research Centre, Nagpur",
    body: "MUHS, Nashik",
  },
];

const EXPERIENCE = [
  {
    id: "experience-consultant",
    role: "Consultant – Pediatrics",
    place: "New Health City Hospital, Nagpur",
    period: "2024 – 2025",
    points: [
      "Managed pediatric OPD and inpatient cases.",
      "Handled common pediatric illnesses and follow-ups.",
      "Coordinated multidisciplinary patient management.",
    ],
  },
  {
    id: "experience-dnb-residency",
    role: "Secondary DNB Residency in Pediatrics and Neonatology",
    place: "Nirmal Hospital Pvt Ltd, Surat",
    period: "2022 – 2024",
  },
  {
    id: "experience-residency",
    role: "Residency in Pediatrics and Neonatology",
    place: "Grant Government Medical College & Sir JJ Group of Hospitals, Mumbai",
    period: "2018 – 2020",
  },
  {
    id: "experience-covid",
    role: "Pediatric and Neonatal COVID-19 Ward and ICU Management",
    place: "Grant Government Medical College & Sir JJ Group of Hospitals, Mumbai",
    period: "2020",
  },
  {
    id: "experience-internship",
    role: "Rotatory Internship",
    place: "NKP Salve Institute of Medical Sciences & Research Centre, Nagpur",
    period: "2015 – 2016",
  },
];

const TimelineItem = ({ item, type }) => (
  <li data-testid={item.id} className="relative pl-10 pb-10 last:pb-0">
    <span
      className="absolute left-0 top-1.5 w-3.5 h-3.5 rounded-full bg-[#70435F] ring-4 ring-[#E8C2CB]/40"
      aria-hidden="true"
    />
    <span className="absolute left-[6.5px] top-6 bottom-0 w-px bg-[#E7DED4]" aria-hidden="true" />
    <p className="text-xs uppercase tracking-[0.18em] font-semibold text-[#B89A69] mb-1.5">{item.period}</p>
    <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#383237] leading-snug">
      {type === "education" ? item.degree : item.role}
    </h3>
    <p className="text-sm text-[#70435F] font-medium mt-1">
      {type === "education" ? item.institution : item.place}
    </p>
    {item.body && <p className="text-sm text-[#8A7E88] mt-0.5">{item.body}</p>}
    {item.points && (
      <ul className="mt-3 space-y-1.5">
        {item.points.map((pt) => (
          <li key={pt} className="text-sm text-[#695E67] leading-relaxed flex gap-2.5">
            <span className="mt-[9px] w-1.5 h-1.5 rotate-45 bg-[#B89A69] shrink-0" aria-hidden="true" />
            {pt}
          </li>
        ))}
      </ul>
    )}
  </li>
);

const Journey = () => (
  <section id="education" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl mb-14">
        <Eyebrow>Education & Experience</Eyebrow>
        <h2
          data-testid="education-heading"
          className="font-display text-3xl sm:text-4xl lg:text-[42px] font-medium tracking-tight text-[#383237] leading-tight mt-5"
        >
          A decade and a half of <em className="italic text-[#70435F]">medical formation</em>
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
        <Reveal>
          <h3 className="text-xs uppercase tracking-[0.22em] font-semibold text-[#8A7E88] mb-8 flex items-center gap-3">
            <span className="w-6 h-px bg-[#B89A69]" aria-hidden="true" />
            Education & Qualifications
          </h3>
          <ul>
            {EDUCATION.map((e) => (
              <TimelineItem key={e.id} item={e} type="education" />
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.12}>
          <h3 className="text-xs uppercase tracking-[0.22em] font-semibold text-[#8A7E88] mb-8 flex items-center gap-3">
            <span className="w-6 h-px bg-[#B89A69]" aria-hidden="true" />
            Professional Experience
          </h3>
          <ul>
            {EXPERIENCE.map((e) => (
              <TimelineItem key={e.id} item={e} type="experience" />
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Journey;
